module.exports = require("ajv-merge-patch");